import { render } from "./CardRegistro.vue?vue&type=template&id=3ba3c862"
import script from "./CardRegistro.vue?vue&type=script&lang=js"
export * from "./CardRegistro.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__